import { ReactElement } from "react";
import { LiveTileContent } from "../LiveTileContent";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { getHubUrlForEvent } from "client/Features/Hub/Events/EventsPage";
import { getHubUrlForKnowledgeItem } from "client/Features/Hub/KnowledgeItems/KnowledgeItemsPage";
import { getHubUrlForAnnouncement } from "client/Features/Hub/Announcements/AnnouncementsPage";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { localize } from "client_legacy/ndaw/culture";
import { HubDataSource } from "client/Api/Hub/hub";
import { hubItemKindToHubDataSourceMap } from "client/Features/Hub/Sidebar/common";
import { never } from "client_legacy/ndaw/errors";
import { isNil } from "client/Misc/utils";

export type HubItemTileFooterProps = {
	onAddAnalyticsEvent: () => void;
	kind: HubItemKind;
	categoryId: number | undefined;
	categoryName?: string;
};

export const HubItemTileFooter = (props: HubItemTileFooterProps): ReactElement => {
	const {
		onAddAnalyticsEvent,
		kind,
		categoryId,
		categoryName
	} = props;

	const navigateHandler = (): void => {
		onAddAnalyticsEvent();

		const source: HubDataSource = hubItemKindToHubDataSourceMap[kind];

		let url: string;

		switch (source) {
			case HubDataSource.KnowledgeItem:
				url = getHubUrlForKnowledgeItem({
					source: HubDataSource.KnowledgeItem,
					viewIdentifier: {
						kind: "categoryId",
						categoryId
					}
				});
				break;
			case HubDataSource.Announcement:
				url = getHubUrlForAnnouncement({
					source: HubDataSource.Announcement,
					categoryId,
					itemId: undefined
				});
				break;
			case HubDataSource.Event:
				url = getHubUrlForEvent({
					source: HubDataSource.Event,
					categoryId,
					itemId: undefined
				});
				break;
			default:
				never(source);
		}

		navigateTo(url);
	};

	const name: string = isNil(categoryId) || isNil(categoryName)
		? localize(itemKindToKeyMap[kind])
		: categoryName;

	return (
		<LiveTileContent.Footer
			name={name}
			onClick={navigateHandler}
		/>
	);
};
HubItemTileFooter.displayName = "TileFooter";

const itemKindToKeyMap: { [key in HubItemKind]: LocalizationKey } = {
	[HubItemKind.Announcement]: "_AllAnnouncements",
	[HubItemKind.KnowledgeItem]: "_AllKnowledgeArticles",
	[HubItemKind.Event]: "_AllEvents"
};
